import { IconWrapper } from '../runtime';
export default IconWrapper('enterprise', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M7.99998 14.2459V1.41592C7.99998 1.21115 7.79937 1.06656 7.60511 1.13132L1.95806 2.93477C1.83556 2.9756 1.75293 3.09024 1.75293 3.21937V12.7493C1.75293 13.5777 2.4245 14.2493 3.25293 14.2493L7.99998 14.2459ZM7.99998 14.2459L12.7483 14.2404C13.5768 14.2404 14.2483 13.5688 14.2483 12.7404V5.71042C14.2483 5.58129 14.1657 5.46665 14.0432 5.42582L7.99998 3.49969",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});